module.exports = __webpack_public_path__ + "img/winter_banner.906bb782.png";